import { render, staticRenderFns } from "./radio-widget.vue?vue&type=template&id=ef35f5b6&scoped=true&"
import script from "./radio-widget.vue?vue&type=script&lang=js&"
export * from "./radio-widget.vue?vue&type=script&lang=js&"
import style0 from "./radio-widget.vue?vue&type=style&index=0&id=ef35f5b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef35f5b6",
  null
  
)

export default component.exports